<template>
  <div>
    <el-table :data="list" stripe border>
      <el-table-column width="60" prop="id" label="ID"></el-table-column>
      <el-table-column prop="key" label="配置"></el-table-column>
      <el-table-column prop="value" label="值"></el-table-column>
      <el-table-column prop="description" label="说明"></el-table-column>
      <el-table-column width="80" align="center" label="操作">
        <template v-slot="scope">
          <el-button @click="handleUpdate(scope.row)" size="mini" type="text">更新</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {sys} from "@/api/sys";
import {msg} from "@/assets/js/my-vue-element-ui-js";

export default {
  name: 'OtherSet',

  data() {
    return {
      list: [],
    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      sys.confList().then(list => {
        this.list = list;
      })
    },
    handleUpdate(conf) {
      this.$prompt("请输入值", "更新配置", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: conf.value,
      }).then(({value}) => {
        sys.confUpdate(conf.key, value).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
          }
        })
      })
    },
  },


};
</script>

<style scoped>
</style>
